import Vue from "vue";

export default {
  /**
   * Set event node configuration
   * @param state
   * @param {Object} config
   */
  setConfig(state, config) {
    state.config = config;
  },
  /**
   * Update DigitalEvent info in vuex state
   * @param state
   * @param {Object} data
   */
  setContext(state, data) {
    Vue.set(state, "context", data);
  }
};
